<template>
  <div class="seat-details">
    <span class="fa fa-chair pr-1 seat-icon" />
    <div class="seat-details__text">
      <span v-if="selectedContractName" class="spot-name">{{ selectedContractName }}</span>
      <span class="spot-starting-at">{{ startingAt }}</span>
      <div class="seat-info">
        <div class="seat-schedule">
          {{ daysOfWeek }}, {{ hoursFromTo }}
          <div class="offer-notes">{{ offerNotes }}</div>
        </div>
        <div class="seat-price">
          {{ formattedCost }}
        </div>
      </div>
      <div class="spot-created-at" v-if="!legupId">{{ createdDate }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: 'seat-details',
  props: {
    selectedContractName: {
      type: String,
      default: null,
    },
    availableAt: {
      type: String,
      required: true,
    },
    createdAt: {
      type: String,
      required: true,
    },
    cost: {
      type: Number,
      default: null,
    },
    costFrequency: {
      type: String,
      default: null,
    },
    daysPerWeek: {
      type: Number,
      default: null,
    },
    daysOfWeek: {
      type: String,
      default: null,
    },
    hoursFromTo: {
      type: String,
      default: null,
    },
    legupId: {
      type: Number,
      default: null,
    },
    offerNotes: {
      type: String,
      default: null,
    },
  },
  methods: {
    formattedDate(dateString) {
      return moment(dateString).utc().format('MMM D, YYYY');
    },
  },
  computed: {
    startingAt() {
      if (this.availableAt) {
        const date = moment(this.availableAt);
        if (date.isBefore(moment())) {
          return 'Available now';
        }

        return `Starting ${this.formattedDate(this.availableAt)}`;
      }
      return '';
    },
    createdDate() {
      return this.createdAt ? `Created ${this.formattedDate(this.createdAt)}` : '';
    },
    formattedCost() {
      if (!this.cost) {
        return '';
      }
      let suffix = this.costFrequency;
      if (['month', 'months'].includes(this.costFrequency)) {
        suffix = 'month';
      } else if (['week', 'weeks'].includes(this.costFrequency)) {
        suffix = 'week';
      } else if (['year', 'years'].includes(this.costFrequency)) {
        suffix = 'year';
      }
      return `$${this.cost / 100} / ${suffix}`;
    },
    formattedDaysPerWeek() {
      return this.daysPerWeek ? `${this.daysPerWeek} ${this.daysPerWeek === 1 ? 'day' : 'days'} / wk` : '';
    },
  },
};
</script>

<style scoped>
.seat-icon {
  font-size: 20px;
  margin-right: 4px;
  position: relative;
  top: 0.5em;
  color: var(--periwinkle-20);
}

.spot-name {
  font-weight: 400;
  font-size: 20px;
}

.seat-details {
  display: flex;
  flex-direction: row;
  margin-bottom: calc(var(--grid-unit) * 2);
}

.seat-details__text {
  line-height: 1.6;
  width: 100%;
}

.spot-starting-at, .spot-created-at {
  font-weight: 500;
  color: var(--periwinkle-50);

  @media screen and (max-width: 768px) {
    display: block;
  }
}

.seat-info {
  display: flex;
  justify-content: space-between;
  color: var(--gray-80);

  @media screen and (max-width: 768px) {
    gap: 8px;
    display: grid;
  }
}

.seat-schedule {
  color: var(--gray-70);
  font-size: 16px;
}

.seat-price {
  color: var(--gray-70);
  white-space: nowrap;
  font-size: 16px;
}

.offer-notes {
  font-weight: 500;
}

</style>
